import React from "react";
import EquipmentReportsListComponent from "../components/report/EquipmentReportsListComponent";

export default function EquipmentReports() {
  return (
    <div>
      <EquipmentReportsListComponent />
    </div>
  );
}
